<div class="wrapper cv-dialog-form">
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				[required]="true"
				[label]="'Origin'"
				[placeholder]="'Select an origin'"
				[options]="originsList"
				[selectedValue]="originSelected"
				[optionText]="'name'"
				(valuesChange)="onOriginSelected($event)"
				[clearSelection]="false"
			>
			</cv-dropdown>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12 product-dropdown">
			<cv-multiselect-search
				[label]="'Product'"
				[placeholder]="'Select a product'"
				[options]="productListOptions"
				[values]="productSelected"
				[optionText]="'name'"
		        [optionValue]="'id'"
				[singleSelectMode]="true"
				[required]="true"
				(valuesChange)="onProductSelected($event)"
			>
			</cv-multiselect-search>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				[required]="true"
				[label]="'Form Type'"
				[placeholder]="'Select a form type'"
				[options]="formTypesList"
				[optionText]="'name'"
				[selectedValue]="formTypeSelected"
				(valuesChange)="onFormTypeSelected($event)"
			>
			</cv-dropdown>
		</div>
	</div>
	<div class="product-check-container mb-4 mt-5">
			<cv-switch
				[class]="'cv-switch-blue'"
				[checked]="ciJobTypeData.isHybridProduct"
				[size]="'sm'"
				(valueChange)="setHybridProduct($event)"
			>
			</cv-switch>
			<span class="info-test">Hybrid Product</span>
	</div>
</div>
